import {DiplomatObject} from 'types/DiplomatObject';
import {DiplomatObjectType} from 'types/DiplomatObjectType';
import * as yup from 'common/yup';
import {AuditReportParameters} from './AuditReportParameters';
import {UserActivityReportParameters} from './UserActivityReportParameters';
import {RecurrenceType} from './RecurrenceType';
import {DayOfMonth} from './DayOfMonth';
import {ReportType} from './ReportType';
import {enums} from 'types/enums';

export const ScheduleReportsNames = {
   objectType: 'objectType',
   type: 'type',
   format: 'format',
   location: 'location',
   schedule: 'schedule',
   auditParams: 'auditParams',
   userParams: 'userParams',
   nextExecution: 'nextExecution',

   dirTemplate: 'dirTemplate',
   fileTemplate: 'fileTemplate',
   recurrenceType: 'recurrenceType',
   recurrenceUnits: 'recurrenceUnits',
   dayOfMonth: 'dayOfMonth',
   baseTime: 'baseTime',
} as const;

export const ScheduledReportsParameters = DiplomatObject.shape({
   [ScheduleReportsNames.objectType]: DiplomatObject.fields.objectType.default(
      DiplomatObjectType.enum.SCHEDULED_REPORT
   ),
   [ScheduleReportsNames.type]: yup
      .string()
      .oneOf(ReportType.keys)
      .default(ReportType.enum.AUDIT_DETAIL),
   [ScheduleReportsNames.format]: yup
      .string()
      .oneOf(enums.reportFormats.keys)
      .default(enums.reportFormats.enum.PDF),
   [ScheduleReportsNames.location]: yup.object({
      [ScheduleReportsNames.dirTemplate]: yup.string(),
      [ScheduleReportsNames.fileTemplate]: yup.string(),
   }),
   [ScheduleReportsNames.schedule]: yup.object({
      [ScheduleReportsNames.recurrenceType]: yup
         .string()
         .oneOf(RecurrenceType.keys)
         .default(RecurrenceType.enum.NEVER),
      [ScheduleReportsNames.recurrenceUnits]: yup.number().integer(),
      [ScheduleReportsNames.dayOfMonth]: yup.originString().oneOf(DayOfMonth.keys).optional(),
      [ScheduleReportsNames.baseTime]: yup.date().default(new Date()),
   }),
   [ScheduleReportsNames.auditParams]: AuditReportParameters,
   [ScheduleReportsNames.userParams]: UserActivityReportParameters,
   [ScheduleReportsNames.nextExecution]: yup.date(),
});
export type IScheduledReportsParameters = yup.InferType<typeof ScheduledReportsParameters>;

/*
"type": "TRANSACTIONS", AUDIT_DETAIL, USER_ACTIVITY
"location": {
    "dirTemplate": "C:\\ProgramData\\Coviant Software\\Diplomat-trial\\reports",
    "fileTemplate": "TransactionsScheduled"
},
"schedule": {
    "recurrenceType": "WEEKLY",
    "recurrenceUnits": 1,
    "dayOfMonth": "ONE",
    "baseTime": "2021-08-05T07:17:00Z"
},
"auditParams": {
    "allRecords": true,
    "byDate": false,
    "byTransactionName": false,
    "containing": false,
    "containingText": "",
    "filenameContaining": false,
    "filenameContainingText": "",
    "fromDate": null,
    "includeArchive": false,
    "toDate": null,
    "transactionNames": []
},
"userParams": {
    "allRecords": true,
    "byDate": false,
    "byObjectId": false,
    "byObjectType": false,
    "byUserId": false,
    "byUserIp": false,
    "fromDate": null,
    "includeArchive": false,
    "objectId": "",
    "objectType": null,
    "toDate": null,
    "userId": "",
    "userIp": ""
},
"nextExecution": "2021-08-12T07:17:00Z"
*/
